import cn from 'classnames';
import { FC, ReactNode, useId } from 'react';
import { useIntl } from 'react-intl';

import { CodeInput, InlineFormError, InputLabel } from '@/shared/ui';

import { MFA_CODE_LENGTH } from '../../config';

import styles from './MFACodeField.module.scss';

type MFACodeFieldProps = {
  value: string;
  label: JSX.Element;
  className?: string;
  errorMessage?: ReactNode;
  disabled?: boolean;
  autoFocus?: boolean;
  onChange: (value: string) => void;
  onComplete?: (value: string) => void;
};

export const MFACodeField: FC<MFACodeFieldProps> = (props) => {
  const {
    value,
    label,
    className,
    errorMessage,
    disabled,
    autoFocus,
    onChange,
    onComplete,
  } = props;

  const { formatMessage } = useIntl();

  const errorID = useId();

  return (
    <div
      className={cn(styles.container, className)}
      data-component="mfa-code-field"
    >
      <InputLabel label={label} required />

      <CodeInput
        value={value}
        length={MFA_CODE_LENGTH}
        error={Boolean(errorMessage)}
        disabled={disabled}
        autoFocus={autoFocus}
        testID="mfa-code-input"
        describedBy={errorMessage ? errorID : undefined}
        onChange={onChange}
        digitLabel={(position, total) =>
          formatMessage(
            {
              id: 'mfa.codeInput.digit',
              defaultMessage: 'Digit {position} of {total}',
            },
            { position, total },
          )
        }
        onComplete={onComplete}
      />

      {errorMessage && (
        <div id={errorID} role="alert">
          <InlineFormError
            className={styles.error}
            errorMessage={errorMessage}
          />
        </div>
      )}
    </div>
  );
};
